import React, { Component } from 'react';

import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';

import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Elevation } from 'rmwc/Elevation';
import { LinearProgress } from 'rmwc/LinearProgress';
import { Snackbar } from 'rmwc/Snackbar';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'

class ExcelUpload extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      loading: false,
      snackbarIsOpen: false,
      data:{
        mcCertTopicId: '',
        submissionDetails: [], 
        artifactURL: '',
        uploadStatus: '',
        uploadDisabled: true,
        uploadedCertId: ''
      },

      fileSize:{
        
        xlsMaxSize:10
      },
      formErrors:{
        fileError:''
      }

    };

    
  }

  componentDidMount() {
    const data = Object.assign({}, this.state.data);
    data.artifactURL = this.props.artifactURL
    data.uploadStatus = this.props.uploadStatus
    data.uploadedCertId = this.props.uploadedCertId
    console.log(data.artifactURL)
    this.setState({ data: data })
  }

  handleUpload =(e) =>{
    e.preventDefault()
    this.setLoadingState(true)
    const formData = new FormData(e.target);
    api.uploadCertArtifact(this.props.user.accessToken,formData)
      .then((result) => {
         const data = Object.assign({}, this.state.data);
         data.artifactURL = result.data.artifact
         data.uploadStatus='yes'
         data.uploadedCertId = result.data.id
         data.uploadDisabled = true
         this.setState({data: data, loading:false, snackbarIsOpen: !this.state.snackbarIsOpen})
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack, loading:false })
        
      })
  }

 handleModify =(e) =>{
    e.preventDefault()
    this.setLoadingState(true)
    const formData = new FormData(e.target);
    api.modifyUploadArtifact(this.props.user.accessToken,formData)
      .then((result) => {
         const data = Object.assign({}, this.state.data);
         data.artifactURL = result.data
         data.uploadStatus='yes'
         data.uploadDisabled= true
         this.setState({data: data, loading:false, snackbarIsOpen: !this.state.snackbarIsOpen})
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack, loading:false})
   
      })
  }

  validateUpload = (event) =>{
    
    let fileSize = event.target.files[0].size/1024/1024;
    let file_name = event.target.files[0].name;
    let file_type = event.target.files[0].type;

    let extension = file_name.substring(file_name.lastIndexOf('.') + 1).toLowerCase();

    if(fileSize < this.state.fileSize.xlsMaxSize){
      if (extension == "xls" || extension == "xlsx"){
        const data = Object.assign({}, this.state.data);
        const formErrors = Object.assign({}, this.state.formErrors);
        formErrors.fileError =''
        data.uploadDisabled = false
        this.setState({data: data, formErrors: formErrors})
      }
      else{
        const formErrors = Object.assign({}, this.state.formErrors);
        const data = Object.assign({}, this.state.data);
        data.uploadDisabled = true
        formErrors.fileError ='Invalid File format. Please check'
        this.setState({formErrors: formErrors, data:data})  
      }
    }
    else{
      const formErrors = Object.assign({}, this.state.formErrors);
      const data = Object.assign({}, this.state.data);
      data.uploadDisabled = true
      formErrors.fileError ='File Size exceeds maximum limit'
      this.setState({formErrors: formErrors, data:data})
    }

  }

  setLoadingState = (stateValue) =>{
    this.setState({loading: stateValue})
  }

  render() {

    let uploadDownloadComponent
    let modifyComponent
    
    let uploadStatus = this.state.data.uploadStatus
    let artifactURL = this.state.data.artifactURL
    let loadingStatus = this.state.loading

    let componentToShow
    let templateComponent

    if(this.props.templateAvailability == 'yes'){
      templateComponent = <a href={this.props.templateUrl} target="_blank"> Template </a> 
    }

    let uploadButtonComponent
    if(!this.state.data.uploadDisabled){
      uploadButtonComponent = <Button dense raised theme="secondary-bg on-secondary">Upload</Button> 
    }
    else{
      uploadButtonComponent = <Button  disabled>Upload new submission</Button> 
    }
    let modifyButtonComponent
    if(!this.state.data.uploadDisabled){
      modifyButtonComponent = <Button dense raised theme="secondary-bg on-secondary">Modify</Button> 
    }
    else{
      modifyButtonComponent = <Button  disabled>Modify existing submission</Button> 
    }

    if(!loadingStatus && uploadStatus === 'no'){

      componentToShow =(
        <form onSubmit={this.handleUpload} style={{width: '100%'}}>
        <Grid className="opportunity-list-item">          
            <GridCell span="1">
              <FormField className="opportunity-form-field">
                <Typography use="subtitle2">{this.props.count}.</Typography>
              </FormField>
            </GridCell>
            <GridCell span="4">
              <FormField className="opportunity-form-field">
                  <div>
                    {this.props.name}
                    <br/>
                    {templateComponent}
                  </div>
              </FormField>
            </GridCell>
            <GridCell span="4">
              <FormField className="opportunity-form-field">
                <div>
                  <input type="file" id="ExcelUpload" name="artifact" onChange={this.validateUpload}/>    
                  <br/>
                  <br/>
                  {uploadButtonComponent}
                </div>  
              </FormField>
            </GridCell>
            <GridCell span="2" className="button-section">
              <TextField autoComplete="off" hidden name="micro_credentials_topic_id"  value={this.props.certId}/>
              <TextField autoComplete="off" hidden name="full_certification_id"  value={this.props.certId}/>
              <TextField autoComplete="off" hidden name="tq_certification_detail_id"  value={this.props.certId}/>
              <TextField autoComplete="off" hidden name="upload_type_id"  value={this.props.uploadTypeId}/>
              <TextField autoComplete="off" hidden name="cert_type"  value={this.props.certType}/>
            </GridCell>         
        </Grid>
        </form>
        )

    }
    else if(!loadingStatus && uploadStatus === 'yes'){
      componentToShow =(
        <form onSubmit={this.handleModify} style={{width: '100%'}}>
        <Grid className="opportunity-list-item"> 
            <GridCell span="1">
              <FormField className="opportunity-form-field">
                <Typography use="subtitle2">{this.props.count}.</Typography>
              </FormField>
            </GridCell>         
            <GridCell span="4">
              <FormField className="opportunity-form-field">
                <div>
                  <Typography use="subtitle2">{this.props.name}</Typography>
                  <br/>
                  {templateComponent}
                </div>
              </FormField>
            </GridCell>
            <GridCell span="4">
                <FormField className="opportunity-form-field">
                  <div>
                    <input type="file" id="VideoUpload" name="artifact" onChange={this.validateUpload}/>
                    <br/>
                    <br/>
                    {modifyButtonComponent}
                  </div>
                </FormField>   
            </GridCell>
            <GridCell span="2">
              <FormField className="opportunity-form-field">
                <a href={artifactURL} target="_blank"> View Submission</a>      
              </FormField>
            </GridCell>                      
            <GridCell span="1" className="button-section">
              <TextField autoComplete="off" hidden name="id"  value={this.state.data.uploadedCertId}/>
              <TextField autoComplete="off" hidden name="cert_type"  value={this.props.certType}/>
            </GridCell>         
        </Grid>
        </form>
        ) 
    }
    else{

      componentToShow =(
        
          <div>  
          <LinearProgress determinate={false}></LinearProgress>
        </div>
        
      )
    }



    let Snackbarcomponent =(
          <Snackbar
            show={this.state.snackbarIsOpen}
            onHide={evt => this.setState({snackbarIsOpen: false})}
            message="Upload successful"
      />
    )

    return (
      
        <GridCell span="12">
          <Elevation z='4'>
            {componentToShow}
            {Snackbarcomponent}
             <StatusMessage error_msg = {this.state.errorMsg}/>
             <StatusMessage error_msg = {this.state.formErrors.fileError}/>
          </Elevation>
        </GridCell>
        
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ExcelUpload);



// WEBPACK FOOTER //
// ./src/views/submissions/ExcelUpload.jsx